import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { WhyItDidntWorkSection } from '../components/WhyItDidntWorkSection';
import { MethodSection } from '../components/MethodSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { MoonIcon } from 'lucide-react';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-cream" data-id="element-254">
      <HeroSection data-id="element-255" />
      <OpeningHookSection data-id="element-256" />
      <ProblemSection data-id="element-257" />
      <WhyItDidntWorkSection data-id="element-258" />
      <MethodSection data-id="element-259" />
      <DeliverablesSection data-id="element-260" />
      <AudienceSection data-id="element-261" />
      <HowItWorksSection data-id="element-262" />
      <ProofSection data-id="element-263" />
      <FAQSection data-id="element-264" />
      <PricingSection data-id="element-265" />

      {/* Footer */}
      <footer className="w-full bg-charcoal py-12 px-4" data-id="element-266">
        <div className="max-w-4xl mx-auto text-center" data-id="element-267">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-268">
            <MoonIcon className="w-6 h-6 text-terracotta" data-id="element-269" />
            <span className="font-heading text-xl text-warmWhite" data-id="element-270">
              Luna Dulce
            </span>
          </div>
          <p className="font-body text-warmGray text-sm" data-id="element-271">
            © 2026 Luna Dulce. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}